'use client'
import { IStaticContent } from '@/root/shared-types'
import { createContext } from 'react'

export const StaticContentContext = createContext<IStaticContent>({})
